import React from 'react';
import PropTypes from 'prop-types';
import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {FLOW_SERIES, formatBucketLabel} from "./FlowChart";
import {WmsStatsPeriod} from "api/wms/stats/stats";
import {greyishBlue50, greyishBlue300, greyishBlue700} from "assets/jss/main";

const COLUMNS = [...FLOW_SERIES, {key: 'shipped', labelId: 'wms.admin_wms_stats.flow.shipped'}]

FlowTable.propTypes = {
    rows: PropTypes.array.isRequired,
    totals: PropTypes.object.isRequired,
    period: PropTypes.oneOf(Object.values(WmsStatsPeriod)).isRequired
};

function FlowTable({rows, totals, period}) {
    const visibleRows = period === WmsStatsPeriod.TODAY
        ? rows.filter(row => COLUMNS.some(column => row[column.key] > 0))
        : rows

    const cellSx = {padding: "6px 12px", fontSize: "13px", color: greyishBlue700, borderBottom: "1px solid " + greyishBlue50}

    return (
        <Table size={"small"} sx={{marginTop: "8px"}}>
            <TableHead>
                <TableRow>
                    <TableCell sx={{...cellSx, color: greyishBlue300, fontWeight: 500}}>
                        <FormattedMessage id={period === WmsStatsPeriod.TODAY ? "wms.admin_wms_stats.table.hour" : "wms.admin_wms_stats.table.day"}/>
                    </TableCell>
                    {COLUMNS.map(column => (
                        <TableCell key={column.key} align={"right"} sx={{...cellSx, color: greyishBlue300, fontWeight: 500}}>
                            <FormattedMessage id={column.labelId}/>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {visibleRows.map(row => (
                    <TableRow key={row.hour ?? row.day}>
                        <TableCell sx={cellSx}>{formatBucketLabel(row, period)}</TableCell>
                        {COLUMNS.map(column => (
                            <TableCell key={column.key} align={"right"} sx={cellSx}>{row[column.key].toLocaleString()}</TableCell>
                        ))}
                    </TableRow>
                ))}
                <TableRow>
                    <TableCell sx={{...cellSx, fontWeight: 600}}><FormattedMessage id={"wms.admin_wms_stats.table.total"}/></TableCell>
                    {COLUMNS.map(column => (
                        <TableCell key={column.key} align={"right"} sx={{...cellSx, fontWeight: 600}}>{totals[column.key].toLocaleString()}</TableCell>
                    ))}
                </TableRow>
            </TableBody>
        </Table>
    );
}

export default FlowTable;
